import { Modal } from 'antd';
import Feather from '@sysunite/react-feather'
import { PlusOutlined } from '@ant-design/icons'
import { useRouteMatch, Link } from "react-router-dom"
import { getUid } from 'Services/WeaverUtils'
import * as Types from 'Types'
import { SpreadSheetView } from 'Model'

treeNodeTypeMap = {
  action: 'service'
  attribute: 'attribute'
  macro: 'form'
  relation: 'relation'
  service: 'service'
  view: 'view'
}

export createRoot = (title, type, key, fn, userMode, writeAccess = false) ->
  {
    key
    path: key
    ['data-testid']: "tree-node-#{key}"
    title: title()
    type
    onExpand: (props) -> fn(props)
    userMode
    writeAccess
  }

export getUpdatedSearchParams = (key, newVal) ->
  params = new URLSearchParams(window.location.search)
  params.set(key, newVal)
  params.toString()

export getCurrentTimeInMillis = ->
  new Date().getMilliseconds()

export getIds = (query) ->
  { node } = await query.find()
  ids = node.map((node) -> getUid(node))

export getIcon = (type) ->
  <Feather
    type={typeToIconMap[type]}
    size={18}
    style={{ marginTop: 3 }}
  />

export createNewItem = (path, key, type) ->
  {
    key: "create-new-#{ key }"
    id: "create-new-#{ key }"
    path: "#{ path }/create-new-#{ key }"
    ['data-testid']: "tree-node-create-new-#{ key }"
    selectable: true
    isLeaf: true
    title: "Create a new #{ _.startCase(treeNodeTypeMap[key]) }"
    type
  }

export ComplexLabel = ({ title, props... }) ->
  { params: { spaceId }} = useRouteMatch()
  <span className="left-panel-tree-item">
    { title }
    <Link
      to="/#{ spaceId }/#{ props.url }"
      className="tree-item-actions"
      onClick={(e) ->
        props.onClick?(e)
      }
    >
      <PlusOutlined
        data-testid={props.testId}
        style={{ marginLeft: '5px' }}
      />
    </Link>
  </span>

export TransformationButtons = ({ count, type, label, transformComponents, props... }) ->
  <span
    className="left-panel-tree-item"
    data-testid="tree-node-#{label}"
  >
    { "#{label} (#{count})" }
    {
      transformComponents?.map((Component, i) ->
        <a
          style={{ marginLeft: '5px' }}
          key="edit-#{label}-#{i}"
          className="tree-item-actions"
          onClick={(e) -> e.stopPropagation()}
        >
          <Component
            key="edit-#{label}-#{i}"
            type={type}
            label={label}
          />
        </a>
      )
    }
  </span>

export editDeleteCtxMenu = (key, editFn, delFn, disabled) -> (props, node) ->
  label = node.get('name')
  menuItems = [{
    key: 'edit-' + key
    danger: false
    disabled: node instanceof SpreadSheetView
    title:
      <span>
        Edit <b>{ label }</b>
      </span>
    onClick: (args...) -> editFn(props, node, args...)
  }]

  if delFn
    menuItems.push({
      key: 'delete-' + key
      danger: true
      title: <span>Delete <b>{ label }</b></span>
      onClick: ({ domEvent }) ->
        domEvent.stopPropagation()
        Modal.confirm({
          title: <span>Are you sure you want to destroy <b>{ label }</b></span>
          icon: <span className="anticon"><Feather type="alert-circle" /></span>
          okText: 'Yes'
          okType: 'danger'
          cancelText: 'No'
          onOk: () -> delFn(props, node)
        })
    })

  menuItems

typeToIconMap = {
  CREATE_VIEW: 'plus'
  QUERY: 'droplet'
  VIEWS: 'copy'
  GROUP: 'folder'
  TYPE: 'box'
  TYPES: 'box'
  CREATE_ACTION: 'plus'
  ACTIONS: 'cloud'
  ACTION: 'command'
  MACROS: 'clipboard'
  MACRO: 'clipboard'
  CREATE_MACRO: 'plus'
  SPREADSHEET: 'layout'
  CREATE_TASK: 'plus'
  TASKS: 'list'
  TASK: 'hash'
  RELATIONS: 'git-branch'
  RELATION_VIEW: 'git-branch'
  ATTRIBUTES: 'list'
  ATTRIBUTE_VIEW: 'circle'
}
